exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-red {\n  padding: 0px 5px 0px 5px;\n  height: 2.3rem;\n  font-size: 18px; }\n\n.btn-danger {\n  height: 2.3rem;\n  border-radius: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend/src/app/shared/schedule-new/schedule-new.component.scss
// module id = ../../../../../src/app/shared/schedule-new/schedule-new.component.scss
// module chunks = main